import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { NotificationService } from '../../../../../core/services/notification.service';
import { CarrierCoverageMapService, ICoverageMapItem } from '../../../services/carrier-coverage-map.service';

@Component({
    selector: 'eci-coverage-map-popup',
    templateUrl: './coverage-map-popup.component.html',
    styleUrls: ['./coverage-map-popup.component.scss']
})
export class CoverageMapPopupComponent implements OnInit {

    public title = 'Coverage map';
    public form: FormGroup;
    public showLoader: boolean = false;
    public isUpdate = false;
    public carrierId: number;
    public info: ICoverageMapItem;

    private errorHandler = (err) => {
        this.notify.showError(err?.error?.message || 'Something went wrong');
        this.showLoader = false;
    }

    constructor(
        public dialogRef: MatDialogRef<CoverageMapPopupComponent>,
        private coverageMapService: CarrierCoverageMapService,
        private notify: NotificationService
    ) {
    }

    ngOnInit(): void {
        if (this.isUpdate) {
            this.title = 'Edit coverage map';
        }
        this.form = this.initializeForm();
    }

    private initializeForm(): FormGroup {
        return new FormGroup({
            postcode: new FormControl(this.info?.postcode || '', [
                Validators.required,
                Validators.maxLength(20),
            ]),
            densityZone: new FormControl(this.info?.densityZone || '', [
                Validators.maxLength(255),
            ]),
        });
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }
        this.showLoader = true;
        const value = this.form.value;
        if (this.isUpdate && this.info?.id) {
            this.coverageMapService.update(this.info.id, value).subscribe(() => {
                this.showLoader = false;
                this.notify.showSuccessMessage('Updated successfully');
                this.dialogRef.close(true);
            }, this.errorHandler);
        } else {
            this.coverageMapService.create({
                carrierId: this.carrierId,
                postcode: value.postcode,
                densityZone: value.densityZone,
            }).subscribe(() => {
                this.showLoader = false;
                this.notify.showSuccessMessage('Created successfully');
                this.dialogRef.close(true);
            }, this.errorHandler);
        }
    }
}
